import { BreadcrumbGroup } from '@cloudscape-design/components';
import useLot from 'features/lots/hooks/useLot';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Breadcrumbs for the Lots section.
 *
 * Route → trail
 * /lots           Home › Lots
 * /lots/:lotId     Home › Lots › L-20260805-003
 * /lots/assemble   Home › Lots › Assemble
 * /lots/trace      Home › Lots › Trace
 */
export default function LotsBreadcrumbs({ pathnames }) {
  const navigate = useNavigate();

  const staticPage = ['assemble', 'trace'].includes(pathnames[1]) ? pathnames[1] : null;
  const lotId = !staticPage ? (pathnames[1] ?? null) : null;
  const { data: lot } = useLot(lotId);

  const items = useMemo(() => {
    const crumbs = [
      { text: 'Home', href: '/' },
      { text: 'Lots', href: '/lots' },
    ];
    if (staticPage) {
      crumbs.push({
        text: staticPage === 'assemble' ? 'Assemble' : 'Trace',
        href: `/lots/${staticPage}`,
      });
    } else if (lotId) {
      crumbs.push({ text: lot?.code || lotId, href: `/lots/${lotId}` });
    }
    return crumbs;
  }, [staticPage, lotId, lot?.code]);

  return (
    <BreadcrumbGroup
      items={items}
      onClick={(e) => {
        e.preventDefault();
        if (e.detail.href) navigate(e.detail.href);
      }}
    />
  );
}

LotsBreadcrumbs.propTypes = {
  pathnames: PropTypes.arrayOf(PropTypes.string).isRequired,
};
